import { h, ComponentChildren, FunctionalComponent } from 'preact'
import cn from 'classnames'
import s from './Option.css'

interface iProps {
  value: string
  label: string
  selected?: boolean
  children: ComponentChildren
}

export const Option: FunctionalComponent<iProps> = (props) => {
  const {
    selected,
    ...restProps
  } = props

  return (
    <button
      class={cn(s.Option, {
        [s.Option_selected]: selected
      })}
      role="option"
      {...restProps}
    />
  )
}
